import React from 'react';
import { Bar } from 'react-chartjs-2';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
} from 'chart.js';

ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
);

const backgroundBarPlugin = {
    id: "backgroundBar",
    beforeDraw(chart: any) {
        const { ctx, scales } = chart;
        const yAxis = scales.y;
        const xAxis = scales.x;
        const dataset = chart.getDatasetMeta(0);

        ctx.save();
        ctx.fillStyle = "rgba(180, 180, 180, 0.15)";

        dataset.data.forEach((bar: any) => {
            if (chart.config.options.indexAxis === "y") {
                ctx.fillRect(xAxis.left, bar.y - bar.height / 2, xAxis.width, bar.height);
            } else {
                ctx.fillRect(bar.x - bar.width / 2, yAxis.top, bar.width, yAxis.height);
            }
        });

        ctx.restore();
    },
};

const EvictionDataChart = () => {
    // Static data for the chart
    const data = [
        { id: 1, threat: "Arbitrary or Unlawful evictions (at night etc)", count: 5000 },
        { id: 2, threat: "Violence and Physical Harm", count: 1500 },
        { id: 3, threat: "Destruction of Property and Basic needs", count: 1000 },
        { id: 4, threat: "Increased risk of exploitation", count: 500 },
        { id: 5, threat: "Disruption of Access to lifesaving/Basic services", count: 350 },
        { id: 6, threat: "Family separation", count: 200 },
        { id: 7, threat: "Psychosocial Impact", count: 150 },
        { id: 8, threat: "Increases Risk of Re-victimization including exploitation", count: 100 },
        { id: 9, threat: "Threats of Livelihood", count: 50 },
        { id: 10, threat: "Displacement Hazards (Accidents, exposure to dangerous terrains)", count: 35 },
        { id: 11, threat: "Others", count: 20 }
    ];

    const chartData = {
        labels: data.map(item => item.threat),
        datasets: [
            {
                label: 'Number of Cases',
                data: data.map(item => item.count),
                backgroundColor: [
                    "#8FA7C7", // dusty blue
                    "#E2E8F0", // light gray-blue
                    "#9DBAD5", // soft blue
                    "#B7C8DB", // pastel blue-gray
                    "#98AFC7", // muted blue
                    "#C0D3E0", // light steel blue
                    "#7F94AF", // slate blue
                    "#A5BCD1", // soft slate
                    "#BACCE0", // ice blue
                    "#6C84A3", // steel blue
                    "#9AB6CD"  // balanced medium blue-grayP
                ],
                borderColor: [
                    "#AFC1DC", // for #8FA7C7
                    "#F0F4FA", // for #E2E8F0
                    "#B4CCE2", // for #9DBAD5
                    "#D0DDEB", // for #B7C8DB
                    "#B2C6DA", // for #98AFC7
                    "#D5E4EE", // for #C0D3E0
                    "#A2B3CA", // for #7F94AF
                    "#C0D2E0", // for #A5BCD1
                    "#D7E2F0", // for #BACCE0
                    "#8DA5C1", // for #6C84A3
                    "#B8CDDD"  // for #9AB6CD
                ],
                borderWidth: 1
            }
        ]
    };

    const options = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                position: 'top' as const,
            },
            title: {
                display: true,
                text: 'Protection Threats and Risks During Evictions',
            },
        },
        scales: {
            x: {
                ticks: {
                    callback: function (_value: any, index: number) {
                        const label = chartData.labels[index];
                        return label.length > 7 ? label.substring(0, 7) + '…' : label;
                    }
                }
            },
            y: {
                beginAtZero: true
            }
        }
    };

    return (
        <div style={{ background: 'white', borderRadius: '8px', boxShadow: '0 2px 10px rgba(0,0,0,0.1)', padding: '20px' }}>
            <div style={{ height: '300px' }}>
                <Bar data={chartData} options={options} plugins={[backgroundBarPlugin]} />
            </div>
        </div>
    );
};

export default EvictionDataChart;
